window.addEventListener('pizza-to-favorite', event => {

    let registerFavoritePersonnalisation = document.getElementById('register-pizza-personnalisation');

    registerFavoritePersonnalisation.classList.add('added-to-cart');

    setTimeout(() => {
        registerFavoritePersonnalisation.classList.remove('added-to-cart');
        registerFavoritePersonnalisation.classList.add('is-transition');

        setTimeout(() => {
            registerFavoritePersonnalisation.classList.remove('is-transition');
        }, 100);
    }, 1900)
})